module.exports = __webpack_public_path__ + "static/media/healthcare_doc-bg.173d8c32.png";